import React from 'react';
import { ParentOrientationDay } from '../views';

const ParentOrientationDayPage = () => {
  return <ParentOrientationDay />;
};

export default ParentOrientationDayPage;
